import { useTranslation } from "react-i18next";
import { ButtonAtom } from "../../../../components/atoms/atom";

function LoginSubmitButton({ onClick, disabled, loading, labelKey }) {
	const { t } = useTranslation();

	return (
		<div className="login-btn-wrap">
			<ButtonAtom
				className="btn btn-primary login-btn"
				onClick={onClick}
				disabled={disabled}
			>
				{loading ? (
					<span className="login-btn-spinner" />
				) : (
					t(labelKey)
				)}
			</ButtonAtom>
		</div>
	);
}

export default LoginSubmitButton;
